module.exports = __webpack_public_path__ + "static/skateboarding-child.2d42b67a.webp";